
import React, { useEffect, useState, useContext, useMemo } from "react";
import DateFormatting from "../../common_components/DateFormatting";
const { DateTime, Duration } = require('luxon');

import RightArrow from "../../../../../../../assets/images/researcher_app/create/purple_arrow_right.png";
import DisabledArrow from "../../../../../../../assets/images/researcher_app/create/gray_arrow_right.png";


const PriorWeekButton = (props) => {
    const className = "week-navigation-div" + (props.active ? "" : " disabled");
    return (
        <div className={className} onClick={props.active ? props.onClick : () => { }}>
            {props.active ?
                <img src={RightArrow} height={20} width={20} style={{ transform: "rotate(180deg)" }} />
                :
                <img src={DisabledArrow} height={20} width={20} style={{ transform: "rotate(180deg)" }} />
            }
            {/* <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M10.8667 12L17 18.1333L15.1333 20L7.13333 12L15.1333 4L17 5.86667L10.8667 12Z" fill="#D4D4D4" />
            </svg> */}
            <div className="week-navigation-text">
                Prior Week
            </div>
        </div>
    )
}

const NextWeekButton = (props) => {
    const className = "week-navigation-div" + (props.active ? "" : " disabled");

    return (
        <div className={className} onClick={props.active ? props.onClick : () => { }}>
            <div className="week-navigation-text">
                Next Week
            </div>
            {props.active ?
                <img src={RightArrow} height={20} width={20} />
                :
                <img src={DisabledArrow} height={20} width={20} />
            }
            {/* <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M13.1333 12L7 5.86667L8.86667 4L16.8667 12L8.86667 20L7 18.1333L13.1333 12Z" fill="#D4D4D4" />
            </svg> */}

        </div>
    )
}


// Helper function to generate time slots
const generateTimeSlots = (start, end) => {
    let slots = [];
    for (let hour = start; hour < end; hour++) {
        // Assuming the time is in 12-hour format with AM/PM
        const period = hour < 12 ? 'am' : 'pm';
        const formattedHour = hour <= 12 ? hour : hour - 12;
        slots.push(`${formattedHour}:00 ${period}`, `${formattedHour}:30 ${period}`);
    }
    return slots;
};

// // Helper function to get the formatted date string
// const getFormattedDate = (date) => {
//     const options = { weekday: 'short', month: 'short', day: 'numeric', timeZone: 'UTC' };
//     return new Intl.DateTimeFormat('en-US', options).format(date);
// };

// // Helper function to add days to a date
// const addDays = (date, days) => {
//     const result = new Date(date);
//     result.setDate(result.getDate() + days);
//     return result;
// };


const TimeSlot = React.memo(({ day, time, isSelected, onMouseDown, onMouseEnter, isPast }) => {
    const slotClasses = `time-slot ${isSelected ? 'selected' : ''} ${isPast ? 'past' : ''}`;
    return (
        <div
            className={slotClasses}
            onMouseDown={() => !isPast && onMouseDown(day, time, 'down')}
            onMouseEnter={() => !isPast && onMouseEnter(day, time, 'enter')}
        >
            {time}
        </div>
    );
});




// Main component
const TimeGrid = (props) => {
    const timezone = props.timezone;
    const [startHour, setStartHour] = useState(8);
    const [endHour, setEndHour] = useState(17);
    const times = useMemo(() => generateTimeSlots(startHour, endHour), [startHour, endHour]);
    const [currentWeekStart, setCurrentWeekStart] = useState(DateFormatting.getMostRecentSundayInTimezone(timezone)); // Tracks the current week start

    const [isDragging, setIsDragging] = useState(false);
    const [dragStartState, setDragStartState] = useState(null); // New state to track the initial action

    const nowInTimezone = useMemo(() => DateTime.fromObject({}, { zone: timezone }));
    // const nowInTimezone = useMemo(() => new Date(new Date().toLocaleString('en-US', { timeZone: timezone })), [timezone]);

    // If, on component mount, there are selected slots befroe 8 AM or after 5 PM, then set the startHour and endHour to show those. 
    useEffect(() => {
        if (props.selectedSlots.size > 0) {
            // Check if there are any slots before 8 AM or after 5 PM
            const before8AM = Array.from(props.selectedSlots).some(slot => {
                const slotDateTime = DateFormatting.timeGridGetDateTimeFromTimeGridString(slot);
                return slotDateTime.hour < 8;
            });
            const after5PM = Array.from(props.selectedSlots).some(slot => {
                const slotDateTime = DateFormatting.timeGridGetDateTimeFromTimeGridString(slot);
                return slotDateTime.hour > 17;
            });
            if (before8AM) {
                setStartHour(0);
            }
            if (after5PM) {
                setEndHour(24);
            }
        }
    }, []);

    const canNavigateToPreviousWeek = useMemo(() => {
        return currentWeekStart > nowInTimezone;
    }, [currentWeekStart]);

    const canNavigateToNextWeek = useMemo(() => {
        const inFourWeeks = DateFormatting.addDays(nowInTimezone, 27);
        return DateFormatting.addDays(currentWeekStart, 7) < inFourWeeks;
    }, [currentWeekStart]);

    // Calculate dates for the current week
    const weekDates = useMemo(() => {
        return Array.from({ length: 7 }, (_, i) => DateFormatting.timeGridFormattedDate(DateFormatting.addDays(currentWeekStart, i)));
    }, [currentWeekStart]);

    // Memoize the calculation for each time slot
    const pastTimeSlots = useMemo(() => {
        let slots = new Set();
        // if (currentWeekStart < DateFormatting.addDays(nowInTimezone, 1)) {
        weekDates.forEach((day, dayIndex) => {
            times.forEach((time) => {
                const slotDate = DateFormatting.addDays(currentWeekStart, dayIndex).startOf('day')
                const slotDateTime = DateFormatting.timeGridGetDateTimeFromDateAndString(slotDate, time);
                if (nowInTimezone > slotDateTime) {
                    slots.add(`${day}-${time}`);
                }
            });
        });
        // }
        return slots;
    }, [nowInTimezone, weekDates, times]);

    // Calculate if the timeslot is in the past. This is used to disable the selection of past time slots
    const isTimeSlotPast = (day, time) => {
        return pastTimeSlots.has(`${day}-${time}`);
    };

    const toggleSlotSelection = (slotId, initialAction = null) => {
        // Calculate the new set of selected slots
        const newSelectedSlots = new Set(props.selectedSlots);
        const action = initialAction !== null ? initialAction : !newSelectedSlots.has(slotId);

        if (action) {
            newSelectedSlots.add(slotId);
        } else {
            newSelectedSlots.delete(slotId);
        }

        // Pass the updated set of selected slots to the parent component's handler
        props.setSelectedSlots(newSelectedSlots);
    };

    const handleWeekNavigation = (direction) => {
        const newWeekStart = DateFormatting.addDays(currentWeekStart, direction === 'next' ? 7 : -7);
        setCurrentWeekStart(newWeekStart);
    };

    const handleMouseDown = (day, time) => {
        const slotId = `${day}-${time}`;
        const initialAction = !props.selectedSlots.has(slotId); // Determine if we are selecting or deselecting
        setDragStartState(initialAction);
        toggleSlotSelection(slotId, initialAction);
        setIsDragging(true);
    };

    const handleMouseEnter = (day, time) => {
        if (isDragging) {
            const slotId = `${day}-${time}`;
            toggleSlotSelection(slotId, dragStartState);
        }
    };

    const handleMouseUp = () => {
        setIsDragging(false); // Stop dragging
        setDragStartState(null); // Reset the initial action on mouse up
    };

    return (
        <div style={{ width: "100%" }}>
            <div className="week-navigation">
                <div><PriorWeekButton onClick={() => handleWeekNavigation('previous')} active={canNavigateToPreviousWeek}>Prior Week</PriorWeekButton></div>
                <TimeGridLegend />
                <div><NextWeekButton onClick={() => handleWeekNavigation('next')} active={canNavigateToNextWeek}>Next Week</NextWeekButton></div>
            </div>
            <div className="time-grid" onMouseUp={handleMouseUp}>
                {weekDates.map((date, dayIndex) => (
                    <div className="date-header" key={`date-${date}}`}>{DateFormatting.timeGridFormattedDate(DateFormatting.addDays(currentWeekStart, dayIndex))}</div>
                ))}
                {startHour == 8 && <ExtendTimeSlotButton text="Show times before 8:00 am" onClick={() => setStartHour(0)} style={{ marginBottom: "4px" }} />}
                {startHour == 0 && <ExtendTimeSlotButton text="Hide times before 8:00 am" onClick={() => setStartHour(8)} style={{ marginBottom: "4px" }} />}
                {times.map((time) => (
                    weekDates.map((date) => (
                        <TimeSlot
                            key={`${date}-${time}`}
                            day={date}
                            time={time}
                            isSelected={props.selectedSlots.has(`${date}-${time}`)}
                            onMouseDown={() => handleMouseDown(date, time)}
                            onMouseEnter={() => handleMouseEnter(date, time)}
                            isPast={isTimeSlotPast(date, time)}
                        />
                    ))
                ))}
                {endHour == 17 && <ExtendTimeSlotButton text="Show times after 5:00 pm" onClick={() => setEndHour(24)} style={{ marginTop: "4px" }} />}
                {endHour == 24 && <ExtendTimeSlotButton text="Hide times after 5:00 pm" onClick={() => setEndHour(17)} style={{ marginTop: "4px" }} />}
            </div>
        </div>

    );
};

function ExtendTimeSlotButton(props) {
    // A full-width row that looks similar to the timegrid slots
    return (
        <div className="extend-time-slot-button" onClick={props.onClick} style={props.style}>
            {props.text}
        </div>
    );

}

function TimeGridLegend() {
    return (
        <div className="time-grid-legend-container">
            <div className="time-grid-legend">
                <div className="legend-item">
                    <div className="legend-square available"></div>
                    <div className="legend-text">Open Time Slots</div>
                </div>
                <div className="legend-item">
                    <div className="legend-square  selected"></div>
                    <div className="legend-text">Your Availability</div>
                </div>
            </div>
        </div>
    )
}

export default TimeGrid;